import axiosInstance from "../../../Services/Global-Services/UnauthorizedTokenHandler";
import { checkStatus, getHeaders } from "../../../Services/SharedSevices/SharedServices";

 const baseURL =  process.env.REACT_APP_BASE_URL;
 
  export const getVersion = async (params) => {
    try {
      const response = await axiosInstance.get(`${baseURL}/Master/Version`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    export const versionDelete = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Master/Version/Delete?id=${params.id}`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

    export const postVersion = async (params) => {
    try {
      const response = await axiosInstance.post(`${baseURL}/Master/Version/Add`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }